<script lang="ts" setup>
import { Icon } from '@brighterly/lib-lumee-ui'

import { useSubscriptionStore } from '@entities/subscription'
import { trackEvent } from '@shared/lib/amplitude'

defineOptions({
  name: 'BannerProcessing',
})

const subscriptionStore = useSubscriptionStore()

const id = computed(() => {
  const value = subscriptionStore.getPaymentRetryData?.subscription?.id || null
  return value ? `#${value}` : ''
})

onMounted(() => {
  trackEvent('Banner_view', {
    feature: 'subscription',
    name: 'retry_payment_processing',
    subscription_id: subscriptionStore.getPaymentRetrySubscriptionId,
  })
})
</script>

<template>
  <div class="processing">
    <div class="processing__info">
      <span class="processing__icon processing__icon--mobile">
        <Icon
          name="arrows-rotate"
          weight="solid"
          size="sm"
          color="inherit"
        />
      </span>
      <div class="processing__content">
        <div class="processing__title btly-text-title-s">
          <span class="processing__icon processing__icon--tablet">
            <Icon
              name="arrows-rotate"
              weight="solid"
              size="sm"
              color="inherit"
            />
          </span>
          Payment for subscription {{ id }} is processing..
        </div>
        <div class="processing__detail btly-text-body-m md:btly-text-body-s xl:btly-text-body-m">
          This may take some time to complete. We'll notify you once it's done.
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./BannerProcessing.scss" />
